import { render, staticRenderFns } from "./CreateClientForm.vue?vue&type=template&id=2265d88a&"
import script from "./CreateClientForm.vue?vue&type=script&lang=ts&"
export * from "./CreateClientForm.vue?vue&type=script&lang=ts&"
import style0 from "./CreateClientForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports